<template>
  <div>
    <StepHeader
      :title="title"
      :theme="theme"
    />

    <StepContent
      width="sm"
      :theme="theme"
    >
      <div class="max-w-500 m-auto">
        <p class="text-center">
          You need to complete the following steps before you can get approved for your loan.
        </p>
        <AppProgressCircleBar
          :next-step="nextStep"
          returning-customer
          :theme="theme"
          :step-labels="stepLabelsComputed"
        />
      </div>
    </StepContent>

    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :fixed-sm="true"
        @click="handleContinue"
      >
        Continue
      </AppButton>

      <Benefits :theme="theme" />
    </StepFooter>

    <Benefits
      :theme="theme"
      mobile
    />
  </div>
</template>

<script>
import StepHeader from '@/components/common/step-layout/StepHeader'
import StepContent from '@/components/common/step-layout/StepContent'
import StepFooter from '@/components/common/step-layout/StepFooter'
import AppButton from '@/components/common/buttons/AppButton'
import AppProgressCircleBar from '@/components/common/progress/AppProgressCircleBar'
import Benefits from '@/components/steps/common/Benefits'
import submitLoans from '@/mixins/submit/submit-loans'
import navigation from '@/mixins/navigation'
import DataLayer from '@/utilities/data-layer'

export default {
  name: 'WelcomeBack',

  // Components
  components: {
    StepHeader,
    StepContent,
    StepFooter,
    AppButton,
    AppProgressCircleBar,
    Benefits
  },

  // Mixins
  mixins: [
    submitLoans,
    navigation
  ],

  // Props
  props: {
    theme: {
      type: String,
      default: 'blue'
    },

    stepLabels: {
      type: [Array, Function],
      required: true
    }
  },

  // Computed
  computed: {
    firstName () {
      return this.$store.state.customer.first_name
    },

    title () {
      return `Welcome Back, ${this.firstName}!`
    },

    nextStep () {
      return this.$store.getters.getNextStepForReturningCustomer
    },

    stepLabelsComputed () {
      return typeof this.stepLabels === 'function' ? this.stepLabels() : this.stepLabels
    }
  },

  // Watch
  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) await this.handleContinue()
      this.$store.dispatch('setTriggerContinue', false)
    }
  },

  created () {
    DataLayer.pushObject({
      event: 'spring_ploan_returning_customer_app_landed'
    })
    window.rudderanalytics.track('spring_ploan_returning_customer_app_landed')
  },

  // Methods
  methods: {
    handleContinue () {
      this.$store.dispatch('setLinearDocumentSteps', false)
      this.handleScreenTimeDataLayer()
      this.$router.push({
        path: this.nextStep,
        query: { ...this.$route.query }
      })
    }
  }
}
</script>
